<template>
  <div id="app">
    <div v-if="load_show">
      <load></load>
    </div>

    <headertop style="z-index:999"></headertop>
    <div class="topping" @click="topping_click()">
      <img  src="../../../assets/Topping.png" style="width: 3.125rem;"></br>
      <!-- <i class="el-icon-arrow-up"></i><!-- </br> -->
      <span>置顶</span>
      </div>
    <div class="main"style="z-index:999">
      <el-col id="height2"  >
        <!-- 面包屑-->
        <el-row style=" margin-bottom: 1rem;">
        </el-row>
        <div ref="screen_all" >
        <el-row style="width: 100%;margin-top: 20px; padding-top: 0.625rem; padding-right: 1.875rem; ">
          <el-row >
            <el-col :span="8" >
              <span style="text-align: center;display: flex;" >
                <el-button type="primary" style="margin-right: 1.25rem;" v-if="all_search.type!='video'" size="mini" @click="search_click()">
                  <i class="el-icon-caret-left"></i>
                  视 频</el-button>
                <el-input placeholder="知识点搜索"  v-model="show.keyword" @keyup.enter.native="all_search_click()" style="width: 100%; " prefix-icon="el-icon-search"    ></el-input>
              </span>
            </el-col>

            <el-col :span="9" :offset="1" v-if="all_search.type=='video'">
              <el-input  placeholder="名称、讲师、课程号"  v-model="show.video_keyword" @keyup.enter.native="search_click()" style="width: 90%; " prefix-icon="el-icon-search"    ></el-input>
            </el-col>

            <el-col :span="4">
              <span  v-if="all_search.type=='video'" style="display: flex; float: right;">
                <el-menu  :default-active="activeIndex" class="el-menu-demo"  mode="horizontal" style="margin-top: -10px">
                  <el-submenu index="2">
                    <template slot="title"style="font-size: 20%;">
                      <span style="color: #409EFF;">课程筛选</span>
                      </template>
                    <el-row>
                      <el-row :style="{width:screen_list.screen_w,height:screen_list.screen_h}" class="shaixuan" >
                        <el-row v-for="item in screen_list.list"  :key="item.num">
                          <el-col style="margin: 0.625rem 0;">
                            {{item.name}}:
                          </el-col>
                          <el-col >
                            <el-tag
                             @click="screen(item_i,item)"  :id="item_i.num+'screen'" style="margin:0.625rem 0.625rem; cursor: pointer; background-color: white;"  v-for="item_i in item.child"  :key="item_i.num">{{item_i.item_name}}</el-tag>
                          </el-col>
                        </el-row>
                        <el-row style="display: flex;justify-content: right;margin-top: 1.25rem;">
                          <el-button round @click="search_b('clean')">清除筛选</el-button>
                          <el-button type="primary" round @click="search_b('determine')">筛选</el-button>
                        </el-row>
                      </el-row>
                    </el-row>
                  </el-submenu>
                </el-menu>
              </span>
            </el-col>
          </el-row>
        </el-row>
       </div>
        <!-- 卡片-->
        <el-row id="text11" v-if="all_search.type=='video'">
          <el-row>
            <el-row style="margin: 1.25rem 0  ;">
              <span v-for="(item,index) in type_list_local" :key="index" @click="local_click(item.type)" >
                <span v-if="index+1!=type_list_local.length" style="font-weight: 900;cursor: pointer;">{{item.name}}
                <span style="margin: 0 5px;"> ></span>
                </span>
                <span v-else>{{item.name}}</span>
              </span>
              <span style="float: right;cursor: pointer;font-weight: 900;color: #409eff;">
                <span style="margin-right: 1.25rem;">
                  <router-link target="_blank" style="text-decoration: none;"  to="coursemap?num=0">课程地图</router-link>
                  </span>
                <span  @click="all_video()" >全部视频</span>
              </span>

            </el-row>
            <el-col :class="item.number=='0' ? 'eachc1' : 'eachc'" v-for="(item,index) in type_list" :key="index"  >
              <el-row v-if="item.number=='0'" >
                <div @click="get_type_click(item.num)">
                  <div style="border-radius: 0.3125rem; border: 1px solid #EBEEF5; background-color: #fff; height: 20vh; padding: 0.8rem  0.5rem; color: #303133;-webkit-transition: .3s;transition: .3s;">
                    <div class="imgh1"  id="img_h" style="cursor: pointer;">
                        <h4 style="font-family:font-family:汉仪宋韵朗黑W;    letter-spacing: 2px; color: rgb(50, 66, 116);padding:1rem;"> {{item.name}}</h4>
                    </div>
                    <div style="padding-top: 0.125rem;" >
                      <div v-if="item.moderator!=0">
                        <h6 class="left">课程顾问：{{item.moderator}}</h6>
                      </div>
                      <div v-else>
                        <h6 class="left">课程数量：{{item.count}}</h6>
                      </div>
                    </div>
                  </div>
                </div>
              </el-row>
              <el-row v-else>
                <div>
                <el-card :body-style="{ padding: '10px' }">
                  <div class="imgh"  @click="video_see(item.serial_number,0,show.resource_type,item)">
                    <img v-if="item.img=='/uploads/company/video/default.jpg'" :src="'https://edu.zhiyaozhishi.com'+item.img"
                                      class="image">
                    <img v-else :src="item.img"
                      class="image">
                  </div>
                  <div style="padding: 5px;"  @click="video_see(item.serial_number,0,show.resource_type,item)">
                    <span v-if="item.hasOwnProperty('identifier')">[{{item.identifier}}]</span>
                    <span v-else>[{{item.number}}]</span>
                    </br>
                     <h6 style="margin: 0;height: 35px;overflow: hidden;"> {{item.name}}</h6>
                      <!-- <el-row v-if="show.table==0 && item.tag.length>0"> -->
                      <el-row v-if="item.tag.length>0" style="overflow: hidden;">
                          <el-col :span="3" :offset="1"  v-for="(i_tag,tag) in item.tag" :key="i_tag"  >
                            <el-tag :type="tag_list[tag].type" v-if="tag<5">{{ item.tag[tag][0]}}</el-tag>
                          </el-col>
                      </el-row>
                      <el-row v-else style="height: 2rem;width: 100%;">
                      </el-row>
                      <div class="bottom clearfix">
                        <h6 style="margin: 0;" class="left" v-if="item.hasOwnProperty('u_time')">{{item.u_time}}</h6>
                        <h6 style="margin: 0;" class="left" v-else>{{item.time}}</h6>
                        <h6 style="margin: 0;" class="right">{{item.teacher}}</h6>
                      </div>
                  </div>
                </el-card>
                </div>
              </el-row>
            </el-col>
          </el-row>

        </el-row>
        <el-row v-else style="margin-top: 1.25rem;">
          <el-row style="height: calc(65vh); overflow: auto;" v-if="all_search.list.length>0">
            <div v-for="(item,index) in all_search.list" :key="index" style=" text-decoration: none;" @click="see_video(item)">
              <el-row style="color: rgb(0, 66, 162);cursor: pointer;font-size: 0.9375rem;padding: 0.3125rem;letter-spacing: 0.125rem">
                {{item.name}}
              </el-row>
              <el-row style="margin: 0.625rem 0;border: 1px solid #ccc;padding: 0.625rem 0.9375rem;letter-spacing: 0.25rem;">
                 {{item.content}}
              </el-row>
            </div>
          </el-row>
          <el-row v-else style="height:calc(65vh) ; display: flex;justify-content: center;align-items: center;">
            <p>未找到您要查询的内容，请重新搜索哦</p>
          </el-row>
        </el-row>
        <br />
        <!-- 分页 -->
        <!-- <div class="block center">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="show.currentPage" :page-sizes="[8, 16, 32, 64]" :page-size="show.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="show.total">
          </el-pagination>
        </div> -->
        <br />
      </el-col>
    </div>
    <footerbom></footerbom>
  </div>
</template>

<script>
  import Header from '../../../components/index/public/NavHeader.vue';
  import Footer from '../../../components/index/public/NavFooter.vue';
  import load from '../../../components/load.vue';
  export default {
    name: 'App',
    data() {
      return {
        tag_list:[{
          type:''
        },
        {
          type:'success'
        },
        {
          type:'info'
        },
        {
          type:'warning'
        },
        {
          type:'danger'
        },
        ],
        type_list_local:[],
        info:{
          brief:'消毒和环境监测是CCS的重要组成部分。为确保制药生产环境的控制保持一致，洁净区的消毒尤其重要。消毒程序应经过验证，证明消毒剂在特定使用方式和表面材料（或代表性材质）上的适用性和有效性，并应支持所制备溶液的使用有效期。环境监测（EM）是生产环境控制效果的评价工具，为了使洁净区的环境质量能得到有效控制和客观评价，应建立科学合理的监测计划，实施全面的监测，并对收集的数据加以有效的分析，将微生物和颗粒的污染风险最小化。',
          detailed:'<p> 1.EU GMP附录1消毒相关内容的解读</p> <p>1.1消毒剂剂的选择与使用</p> <p>1.2消毒剂的轮换</p> <p>1.3消毒剂的效力验证、使用有效期验证等。</p> <p>2.EU GMP附录1环境监测相关内容的解读</p> <p>2.1取样点、取样频率的评估</p> <p>2.2检测方法的确认</p> <p>2.3微生物鉴定、数据分析等。</p>   '
        },
        load_show:false,
        all_search:{
          input:'',
          list:[],
          type:'video'
        },
        type_list:[],
        screen_list:{
          screen_w:'',//宽度
          screen_h:'',
          user_list:[],
          list:[],
        },
        show:{
          list:[],
          tag:'',
          currentPage: 1, // 当前页码
          total: 0, // 总条数
          pageSize: 9999,
          class_tyep:this.$route.query.type,//分类参数
          keyword:this.$route.query.keyword,//知识点搜索
          video_keyword:this.$route.query.video_keyword,//视频搜索
          selest:this.$route.query.selest,//只是点搜索
          type:'all',
          resource_type:'l',
          address:[],
          // class_tyep:0
        },
        search:'',
        activeIndex: '2',
      }
    },
    components: {
      headertop: Header,
      footerbom: Footer,
      load:load
    },
    mounted:function(){
      //监听浏览器返回
      // if (window.history && window.history.pushState) {
      //     history.pushState(null, null, document.URL);
      //     window.addEventListener('popstate', this.goPageBefore, false);
      //  }
       // if(this.show.fid!='' && this.show.fid!=undefined){
       //   // this.all_search.type='selest'
       //   this.all_search.input=this.fid
       //   this.all_search_click()
       // }else{
       //   this.get_tag()
       //   this.get_type(this.show.table
       // }
       this.get_tag()
       if(this.show.video_keyword!='' && this.show.video_keyword!=undefined){
         this.get_video()
         return
       }
       if(this.show.selest!='' && this.show.selest!=undefined){
         this.screen_list.user_list=this.show.selest.split(',')
         // this.get_video()

         return
       }
        this.get_type(this.show.class_tyep)
       // this.get_type_Navigation(19)

      this.screen_list.screen_w=this.$refs.screen_all.offsetWidth*0.5+'px'
      this.screen_list.screen_h=window.innerHeight*0.6+'px'
    },
    watch:{
      $route(to,from){
        // this.show.table=to.query.type
        // this.get_type(to.query.type)
        this.get_tag()
      }
    },
    methods: {
      all_video(){
        let _this=this
        _this.load_show=true
        _this.axios.get('/v2/user_resource/get_video',{params:{tag:'',type:'all',table:0,page:1,limit:99999,'keyword':''}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.load_show=false
              _this.show.resource_type=res.data.data.resource_type
              _this.type_list=res.data.data.list.data
              _this.type_list_local=res.data.data.address
              _this.type_list_local[0]['type']=0
            }else{
              _this.$message.error(res.data.msg)
              _this.load_show=false
            }
          }else{
            _this.$message.error('服务器内部错误')
            _this.load_show=false
          }}).catch(function(error) {
          _this.$message.error('服务器内部错误').
          _this.load_show=false
        });
      },
      topping_click(){
        document.documentElement.scrollIntoView({ behavior: "auto" });
      },
      get_video(){
        let _this=this;
        _this.load_show=true
        _this.axios.get('/v2/user_resource/get_video',{params:{tag:_this.show.tag,type:'all',table:0,page:1,limit:9999,'keyword':_this.show.video_keyword}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.load_show=false
               _this.show.resource_type=res.data.data.resource_type
               _this.type_list=res.data.data.list.data
               _this.type_list_local=res.data.data.address
               _this.type_list_local[0]['type']=0
              for(let i=0;i<_this.screen_list.list.length;i++){
                for(let j=0;j<_this.screen_list.list[i].child.length;j++){
                  if(_this.screen_list.list[i].child[j].type==true){
                    document.getElementById(_this.screen_list.list[i].child[j].num+'screen').style.color="red"
                    document.getElementById(_this.screen_list.list[i].child[j].num+'screen').style.border="1px solid red"
                  }
                }
              }
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
        // _this.screen_list.user_list=[]
        // _this.show.tag=''
      },
      local_click(num){
        this.$router.push({path:'/Opencourses_tow',query:{type:num,keyword:'',video_keyword:'',selest:'',}})
        this.$router.go(0)
      },
      get_type_click(num){
        this.$router.push({path:'/Opencourses_tow',query:{type:num,keyword:this.show.keyword,video_keyword:'',selest:'',}})
        this.$router.go(0)
      },
      // goPageBefore(){
      //   this.$router.go(0)
      //    }  ,
      //视频跳转
      video_see(num,type,resource,item){
        let url=''
        if(item.hasOwnProperty('serial_number')){
          if(this.$store.state.info.company.name=='北京睿知而行科技有限公司'){
             url= this.$router.resolve({path:'/video_info',query:{num:item.serial_number}})
          }else{
            url= this.$router.resolve({path:'/courseplay',query:{num:item.serial_number,type:0,resource:resource}})
          }

        }else{
          if(this.$store.state.info.company.name=='北京睿知而行科技有限公司'){
             url= this.$router.resolve({path:'/video_info',query:{num:item.num}})
          }else{
           url= this.$router.resolve({path:'/courseplay',query:{num:item.num,type:0,resource:resource}})
           }
        }

        window.open(url.href,"_blank")
      },
      //知识点搜索视频
      see_video(item){
        let url= this.$router.resolve({path:'/courseplay',query:{num:item.num,type:0,resource:'v'}})
        window.open(url.href,"_blank")
      },
      all_search_click(){
        let _this=this

        if(_this.show.keyword==''){
          _this.$message.error('搜索内容不能为空哦！')
          return
        }
        _this.all_search.type='selest'
        _this.$router.push({path:'/Opencourses_tow',query:{type:0,keyword:_this.show.keyword,video_keyword:'',selest:'',}})
        _this.show.currentPage=1
        // _this.show.total=0
        _this.show.pageSize=6
        _this.all_search_video()
      },
      all_search_video(){
        let _this=this
        _this.load_show=true
        _this.axios.get('/v2/user_resource/video_sign_search',{params:{page:_this.show.currentPage,limit:99999,key:_this.show.keyword}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.load_show=false
              _this.all_search.list=res.data.data.data
              _this.show.total=res.data.data.total
            }else{
              _this.$message.error(res.data.data.msg)
              _this.load_show=false
            }
          }else{
            _this.$message.error('服务器内部错误')
            _this.load_show=false
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
          _this.load_show=false
        });
      },
      get_tag(){
        let _this=this
          _this.axios.get('/v2/user_resource/get_tag').then(function(res) {
            if(res.status=='200'){
              if(res.data.code=='1'){
                _this.screen_list.list=res.data.data
                if(_this.show.selest!='' && _this.show.selest!=undefined){
                  _this.show.selest= _this.show.selest.split(',')
                  for(let i=0;i<_this.show.selest.length;i++){
                    if(_this.show.selest[i]!=''){
                      for(let j=0;j<_this.screen_list.list.length;j++){
                        for(let q=0;q<_this.screen_list.list[j].child.length;q++){
                          if(_this.show.selest[i]==_this.screen_list.list[j].child[q].num){
                            _this.screen_list.list[j].child[q].type=true
                          }
                        }
                      }
                    }
                  }
                  _this.get_video()
                }
              }else{
                _this.$message.error(res.data.msg)
              }
            }else{
              _this.$message.error('服务器内部错误')
            }
          }).catch(function(error) {
            _this.$message.error('服务器内部错误')
          });
      },
      search_b(type){
        if(type=='clean'){
          this.$router.push({path:'/Opencourses_tow',query:{type:'0',keyword:'',video_keyword:'',selest:'',}})
          this.$router.go(0)
        }else{
          for(let i=0;i<this.screen_list.user_list.length;i++){
            if(this.screen_list.user_list[i]!=''){
              this.show.tag=this.screen_list.user_list.join(',')
              this.$router.push({path:'/Opencourses_tow',query:{type:'',keyword:'',video_keyword:'',selest:this.show.tag,}})
              this.$router.go(0)
              return
            }else{
              this.$router.push({path:'/Opencourses_tow',query:{type:'0',keyword:'',video_keyword:'',selest:'',}})
              this.$router.go(0)
            }
          }
        }

      },
      screen(item,item_all){
        if(item.type==true){
          item.type=false
          document.getElementById(item.num+'screen').style.background="white"
          document.getElementById(item.num+'screen').style.color="#409EFF"
          document.getElementById(item.num+'screen').style.border="1px solid #d9ecff"
        }else{
          for(let i=0;i<item_all.child.length;i++){
            item_all.child[i].type=false
            document.getElementById(item_all.child[i].num+'screen').style.background="white"
            document.getElementById(item_all.child[i].num+'screen').style.color="#409EFF"
            document.getElementById(item_all.child[i].num+'screen').style.border="1px solid #d9ecff"
          }
          document.getElementById(item.num+'screen').style.background="#ecf5ff"
          item.type=true
        }
        for(let i=0;i<this.screen_list.list.length;i++){
          if(item_all.num==this.screen_list.list[i].num){
            if(item.type==false){
              this.screen_list.user_list[i]=''
            }else{
              this.screen_list.user_list[i]=item.num
            }
          }
        }
      },
      search_click(){
        this.$router.push({path:'/Opencourses_tow',query:{type:this.show.class_tyep,keyword:this.show.keyword,video_keyword:this.show.video_keyword,selest:'',}})
        this.$router.go(0)
      },
      get_type(type){
        let _this=this;
        _this.load_show=true
        _this.axios.get('/v2/user_resource/get_type_new',{params:{type:type,limit:_this.show.pageSize,page:_this.show.currentPage}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.type_list=res.data.data.data
              _this.type_list_local=res.data.data.local
              _this.load_show=false
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },
      change_show(type){
        this.search=''

      },
      check_type(event,type){
        let _this=this
        if(event.currentTarget.parentElement.nextElementSibling.childElementCount==0){

        }
      },
      handleSizeChange(val) {
        this.show.currentPage = 1
        this.show.pageSize = val
        if(this.all_search.type=='video'){
          this.get_type(this.show.class_tyep)
        }else{
          this.all_search_video()
        }
      },
      handleCurrentChange(val) {
        this.show.currentPage = val
        if(this.all_search.type=='video'){
          this.get_type(this.show.class_tyep)
        }else{
          this.all_search_video()
        }
      },
      /* 新标签页*/
      goPage(url) {
        window.open(url, '_blank');
      },
    },
    // destroyed(){
    //      window.removeEventListener('popstate', this.goPageBefore, false);
    // },

  }
</script>

<style scoped>
  .tag_true{
    background-color: #ecf5ff;
  }
  .tag_flast{
    background-color: white;
  }
  .shaixuan{
    overflow-y: auto;
  }
 >>> .el-col>.el-menu[data-v-1b536c89]{
    min-height:0;

  }
  .main {
    min-height: calc(100vh - 290px);
    width: 70%;
    padding: 0;
    margin: 0 15%;
    z-index: 100;
    background-color: white;
    overflow: hidden;

  }

  h1 {
    /* color: white; */
    margin: 20px;
  }

  /* 导航 */
  .el-col>.el-menu {
    min-height: calc(100vh - 290px);
    overflow: hidden;
    padding: 20px 0;
    width: 100%;
  }

.el-menu--inline,
.el-menu-item-group>ul
.el-menu-item-group>ul>li{
    width: 100% !important;
  }

.el-menu-item-group__title {
    margin: 0;
    padding: 0;
  }

  #height1>i {
    /* color: white; */
  }

.el-submenu__title {
    width: 100%;
    height: 40px;
    min-height: 40px;
    line-height: 40px;
    font-weight: 600;
    padding: 0 !important;
  }

.el-icon-arrow-down{
    right: 0 !important;
  }
#height1>.el-submenu__title>span,
#height1>.el-menu-item {
    width: 100% !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: normal !important;
  }

  .el-submenu {
    width: 100%;
    /* margin-bottom: 20px; */
  }
/* 面包屑 */
.el-breadcrumb{
  margin: 35px;
}
  /* 卡片 */
  .el-row {
    width: 98%;
    padding-left: 2%;
  }

  .image {
    width: 100%;
    display: block;
    height: 100%;
    position: absolute;
  }
  .image1
  {
    width: 70%;
    /* margin-left: 10%; */
    display: block;
    height: 80%;
    position: absolute;
  }
  .image2
  {
    width: 1rem;
    height: 1rem;
  }
  .imgh {
    width: 100%;
    padding-bottom: 56.25%;
    height: 0;
    position: relative;
  }
  .imgh1 {
    width: 100%;
    /* padding-bottom: 56.25%; */
    background-image: url(../../../assets/video_type1.jpg);
    background-size: 100%;
     background-repeat:no-repeat;
     display: flex;
     justify-content: center;
     align-items: center;
     /* height: 0; */
     height: calc(15vh);
  }

  .eachc {
    margin: 10px;
    width: calc(25% - 20px);
  }
  .eachc1 {
    margin: 10px;
    width: calc(25% - 20px);
  }

  .bottom {
    margin-top: 13px;
    line-height: 12px;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both;
  }

  #height1 {
    /* background-color: rgb(51, 99, 151); */
    border-right: 2px dashed rgb(51, 99, 151);
    padding: 20px;

  }
     .el-menu{
       border: none;
     }
#text11 a{
  text-decoration:none;
}

.el-submenu .el-menu-item {
    height: 25px;
    line-height: 25px;
    padding: 0 45px;
    min-width: 200px;
}
.router-link-active {
  text-decoration: none;
}
.topping{
  position: fixed;
  right:9%;
  bottom: 20px;
   box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
   background-color: white;
    border-radius: 4px;
    padding: 0.5rem;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/view/index/Courses/Opencourses_tow.vue